// Generated by ReScript, PLEASE EDIT WITH CARE


function getTabUId(tab) {
  if (typeof tab === "number") {
    switch (tab) {
      case /* Test */0 :
          return /* Test */41;
      case /* AllocationDashboard */1 :
          return /* AllocationDashboard */63;
      case /* SendSMS */2 :
          return /* SendSms */65;
      
    }
  } else {
    switch (tab.TAG | 0) {
      case /* PretendAsCaller */0 :
          return /* PretendAsCaller */59;
      case /* CustomerCallerInfo */1 :
          return /* CustomerCallerInfo */61;
      case /* CustomerProfileNew */2 :
          return /* CustomerProfileNew */62;
      case /* CustomerOrder */3 :
          return /* CustomerOrder */20;
      case /* UnknownCaller */4 :
          return /* UnknownCaller */60;
      case /* DriverDashboardV2 */5 :
          return /* DriverDashboardV2 */0;
      case /* DriverSuspensionList */6 :
          return /* DriverSuspensionList */1;
      case /* DriverTerminationList */7 :
          return /* DriverTerminationList */2;
      case /* DriverWallet */8 :
          return /* DriverWallet */3;
      case /* OrderDetail */9 :
          return /* OrderDetail */4;
      case /* OrderDetails */10 :
          return /* OrderDetails */5;
      case /* OrderFare */11 :
          return /* OrderFare */6;
      case /* NewAdjustFare */12 :
          return /* NewAdjustFare */64;
      case /* OrderLogs */13 :
          return /* OrderLogs */7;
      case /* RaiseTicket */14 :
          return /* RaiseTicket */8;
      case /* EditDriver */15 :
          return /* EditDriver */9;
      case /* DriverTickets */16 :
          return /* DriverTickets */10;
      case /* DriverIncentivesList */17 :
          return /* DriverIncentivesList */11;
      case /* DriverPenalties */18 :
          return /* DriverPenalties */12;
      case /* DriverWeeklyEarningDetails */19 :
          return /* DriverWeeklyEarningDetails */13;
      case /* SurgeDashboard */20 :
          return /* SurgeDashboard */14;
      case /* MbgCampaignInfo */21 :
          return /* MbgCampaignInfo */25;
      case /* InternalRedirectPath */22 :
          return /* InternalRedirectPath */27;
      case /* ViewTickets */23 :
          return /* ViewTickets */28;
      case /* ViewTicketDetails */24 :
          return /* ViewTicketDetails */29;
      case /* EditOrder */25 :
          return /* EditOrder */30;
      case /* CreatePenalty */26 :
          return /* CreatePenalty */32;
      case /* SendInvoice */27 :
          return /* SendInvoice */33;
      case /* GetOrderFareDetails */28 :
          return /* GetOrderFareDetails */34;
      case /* GiveGoodwillDiscount */29 :
          return /* GiveGoodwillDiscount */35;
      case /* SMSDetails */30 :
          return /* SMSDetails */36;
      case /* ViewCityTollRoutes */31 :
          return /* ViewCityTollRoutes */37;
      case /* GiveGoodwillPartnerBonus */32 :
          return /* GiveGoodwillPartnerBonus */38;
      case /* RaiseTicketFromAgentDesk */33 :
          return /* RaiseTicketFromAgentDesk */39;
      case /* EditTicket */34 :
          return /* EditTicket */56;
      case /* CustomerProfile */35 :
          return /* CustomerProfile */40;
      case /* HelperServiceabilityInfoList */36 :
          return /* HelperServiceabilityInfoList */45;
      case /* OutStationServiceabilityInfoList */37 :
          return /* OutStationServiceabilityInfoList */46;
      case /* RentalServiceabilityInfoList */38 :
          return /* RentalServiceabilityInfoList */47;
      case /* PremiumPartnerReport */39 :
          return /* PremiumPartnerReport */48;
      case /* FilterOrders */40 :
          return /* FilterOrders */50;
      case /* FilterPartner */41 :
          return /* FilterPartner */51;
      case /* Tickets */42 :
          return /* Tickets */52;
      case /* Ticket */43 :
          return /* Ticket */53;
      case /* PricingDashboard */44 :
          return /* PricingDashboard */54;
      case /* HelperLabourServiceability */45 :
          return /* HelperLabourServiceability */55;
      case /* CampaignOrders */46 :
          return /* CampaignOrders */57;
      case /* TrustAndSafety */47 :
          return /* TrustAndSafety */58;
      case /* PlaceOrder */48 :
          return /* PlaceOrder */66;
      case /* DriverLeadPage */49 :
          return /* DriverLeadPage */67;
      
    }
  }
}

export {
  getTabUId ,
  
}
/* No side effect */
